@let regDocUrl = regDocUrl$ | async;
<article class="ecl-u-type-m ecl-u-mt-l ecl-u-mt-lg-m ecl-u-pb-l ecl-u-pb-lg-m" *ngIf="document">
    @if(!showOnlyDetails) {
    <a tabindex="0" eclLink variant="standalone"
       (click)="navigateToDocumentDetails(document, regDocUrl)"
       class="ecl-u-type-bold"
       [class.eui-ecl-u-cursor-pointer]="document.hasCases"
       [class.ecl-u-type-prolonged-l]="document.hasCases"
       >{{document.documentTitle}}</a>
    }
    <div class="ecl-row ecl-u-d-flex ecl-u-align-items-center">
        <div class="ecl-col-12">
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-xs ecl-u-mt-m">
                        {{'easeportal.search.REFERENCE' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9">
                    <p class="ecl-u-type-paragraph ecl-u-mv-2xs ecl-u-mt-m ">
                        {{document.referenceNumber}}
                    </p>
                </div>
            </div>
            <div class="ecl-u-d-flex" *ngIf="document.documentVersion">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.VERSION' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9">
                    <p class="ecl-u-type-paragraph ecl-u-mv-2xs">
                        {{document.documentVersion}}
                    </p>
                </div>
            </div>
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.DISCLOSED-BY' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9" *ngIf="document.disclosedBy">
                    <span class="ecl-u-type-paragraph">
                        {{ document.disclosedBy }} - {{ commissionDepartmentsEnum.resourceKey(document.disclosedBy) |
                        translate}}
                    </span>
                </div>
            </div>
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.DISCLOSURE-DATE' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9">
                    <p class="ecl-u-type-paragraph ecl-u-mv-2xs">
                        {{ document.disclosureDate | date: 'dd/MM/yyyy' }}
                    </p>
                </div>
            </div>
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.PUBLISHING-DATE' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9">
                    <p class="ecl-u-type-paragraph ecl-u-mv-2xs">
                        {{ document.publishingDate | date: 'dd/MM/yyyy' }}
                    </p>
                </div>
            </div>
            <div class="ecl-u-d-flex"
                 *ngIf="document.exceptionsInvolved && document.disclosureType === disclosureTypeEnum.PARTIAL">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.EXCEPTIONS-INVOLVED' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9 ecl-u-mv-2xs">
                    <p class="ecl-u-type-paragraph ecl-u-mv-none" *ngFor="let exception of document.exceptionsInvolved">
                        {{exceptionsInvolvedEnum.resourceKey(exception) | translate}}
                    </p>
                </div>
            </div>
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.DISCLOSURE-TYPE' | translate}}
                    </p>
                </div>
                <span eclTag
                      class="ecl-u-type-color-accent-40 ecl-u-ph-2xl ecl-u-type-bold"
                      [class.ecl-u-bg-success]="document.disclosureType === DisclosureTypeEnum.FULL_ACCESS"
                      [class.ecl-u-bg-warning]="document.disclosureType === DisclosureTypeEnum.PARTIAL">
                      {{ (disclosureTypeEnum.resourceKey(document.disclosureType)) | translate }}
                </span>
            </div>
            <div class="ecl-u-d-flex">
                <div class="ecl-col-3 ecl-u-pl-none">
                    <p class="ecl-u-type-paragraph ecl-u-type-bold ecl-u-mv-2xs">
                        {{'easeportal.search.ASSOCIATED-KEYWORDS' | translate}}
                    </p>
                </div>
                <div class="ecl-col-9">
                    <div class="ecl-u-type-paragraph ecl-u-mv-2xs">
                        <button eclTag variant="removable" class="ecl-u-mr-xs ecl-u-type-none"
                                *ngFor="let keyword of document.associatedKeywords">
                            {{keyword}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <section *ngIf="!showOnlyDetails && !document.fetchFromRegDoc; else fetchFromRegDoc"
             class="ecl-u-mb-l ecl-u-d-flex">

        <!-- Preview button -->
        <button eclButton variant="primary" class="ecl-u-mt-m" (click)="previewDocument(document)">
            <ecl-icon icon="eye" size="s">
            </ecl-icon>&nbsp;
            <span eclButtonLabel>{{'easeportal.search.PREVIEW' | translate}}</span>
        </button>&nbsp;&nbsp;
        <!-- Download button -->
        <button eclButton variant="secondary" class="ecl-u-mt-m"
                (click)="downloadDisclosedDocument(document)"
                *ngIf="document.numFiles === 1">
            <span eclButtonLabel>{{
                    'easeportal.common.DOWNLOAD' | translate}}</span>&nbsp;&nbsp;
            <ecl-icon icon="download" size="s">
            </ecl-icon>
            &nbsp;
        </button>
        <!-- Download all button -->
        @if (document.numFiles > 1) {
        <button eclButton variant="secondary" class="ecl-u-mt-m ecl-u-pa-2xs"
                (click)="downloadDisclosedDocumentAsZip(document)">
            <img src="assets/images/zip-icon-blue.svg" style="width: 2em;height: 2em;"
                 class="ecl-icon ecl-icon--ui--download ecl-icon--fluid ecl-link__icon">
            &nbsp;
            <span eclButtonLabel>{{ 'easeportal.search.DOWNLOAD-ALL' | translate}}
                ({{document.numFiles}})</span>&nbsp;&nbsp;
            <ecl-icon icon="download" size="s"></ecl-icon>&nbsp;
        </button>
        }
    </section>
    <ng-template #fetchFromRegDoc>
        <p class="ecl-u-type-paragraph italic" *ngIf="!showOnlyDetails" [innerHTML]="'easeportal.search.DOCUMENT-PUBLISHED-ON-REGDOC' | translate : {
        link: finalRegDocUrl }">
        </p>
    </ng-template>

</article>

<eui-dialog #dialogPdf [title]="'easeportal.modal.document-preview.TITLE' | translate"
            [hasFooter]="false"
            (close)="clearPDFList()"
            eclModal class="sgp-document-viewer-modal" customWidth="80%">
    <app-sgp-pdf-viewer [pdfDocumentList]="pdfList">
    </app-sgp-pdf-viewer>
</eui-dialog>

